import styled from 'styled-components';
import * as Colors from '../../constants/Colors';
import { FlexBox } from '../../layout/FlexBox';
import { SvgIconProps } from '../../icons/IconProps';
import { BaseSvgIcon } from '../../icons/BaseSvgIcon';
import { MarginProps, ValueOf } from '../../types';

export type LoadingProps = SvgIconProps & {
    color: string;
    margin?: ValueOf<MarginProps>;
};

const StyledIcon: React.FC<LoadingProps> = styled(BaseSvgIcon)<LoadingProps>`
    circle {
        fill: ${(props) => (props.color === 'inherit' ? 'currentColor' : props.color)};
    }
`;

export const LoadingImage = (props: LoadingProps) => (
    <StyledIcon viewBox="0 0 120 30" {...props}>
        <circle cx="15" cy="15" r="15">
            <animate
                attributeName="r"
                from="15"
                to="15"
                begin="0s"
                dur="0.8s"
                values="15;9;15"
                calcMode="linear"
                repeatCount="indefinite"
            />
            <animate
                attributeName="fill-opacity"
                from="1"
                to="1"
                begin="0s"
                dur="0.8s"
                values="1;.5;1"
                calcMode="linear"
                repeatCount="indefinite"
            />
        </circle>
        <circle cx="60" cy="15" r="9" fillOpacity="0.3">
            <animate
                attributeName="r"
                from="9"
                to="9"
                begin="0s"
                dur="0.8s"
                values="9;15;9"
                calcMode="linear"
                repeatCount="indefinite"
            />
            <animate
                attributeName="fill-opacity"
                from="0.5"
                to="0.5"
                begin="0s"
                dur="0.8s"
                values=".5;1;.5"
                calcMode="linear"
                repeatCount="indefinite"
            />
        </circle>
        <circle cx="105" cy="15" r="15">
            <animate
                attributeName="r"
                from="15"
                to="15"
                begin="0s"
                dur="0.8s"
                values="15;9;15"
                calcMode="linear"
                repeatCount="indefinite"
            />
            <animate
                attributeName="fill-opacity"
                from="1"
                to="1"
                begin="0s"
                dur="0.8s"
                values="1;.5;1"
                calcMode="linear"
                repeatCount="indefinite"
            />
        </circle>
    </StyledIcon>
);

export const Loading = ({ margin, ...props }: LoadingProps) => (
    <FlexBox width="100%" height="100%" alignItems="center" justifyContent="center" margin={margin}>
        <LoadingImage {...props} />
    </FlexBox>
);

Loading.defaultProps = {
    color: Colors.hsBlue,
    height: '18px',
};
